import React from 'react';

export default class HostRewardsTab extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
	    //console.log('props:');
	    //console.log(this.props);
		return (
			<div className="active clearfix animate-in">
                <div className="wrapper">
		            <div data-resource="PWS.MyAccount.HostRewardsContent" dangerouslySetInnerHTML={{__html: this.props.resources['PWS.MyAccount.HostRewardsContent']}} />
		        </div>
				
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/Tab_HostRewards.js